import React from 'react';
import PropTypes from 'prop-types';
import { useEcommerceContext } from '@blaze-cms/ecommerce-context';
import FlyOutBasketItem from './FlyOutBasketItem';
import LoadingOverlay from '../LoadingOverlay';

const FlyOutBasketItems = ({ basketItems, className }) => {
  const itemsClassName = `${className}__items`;
  const { isCartLoading } = useEcommerceContext();

  return (
    <div className={itemsClassName}>
      {isCartLoading && <LoadingOverlay />}
      {basketItems.map(basketItem => {
        const { productId, variantId } = basketItem;
        const itemKey = `${productId}-${variantId}`;

        return (
          <FlyOutBasketItem
            key={itemKey}
            basketItem={basketItem}
            lineItems={basketItems}
            className={itemsClassName}
          />
        );
      })}
    </div>
  );
};

FlyOutBasketItems.propTypes = {
  basketItems: PropTypes.array.isRequired,
  className: PropTypes.string.isRequired
};

export default FlyOutBasketItems;
